import { render } from "./MemberTop.vue?vue&type=template&id=413ac423&scoped=true"
import script from "./MemberTop.vue?vue&type=script&lang=js"
export * from "./MemberTop.vue?vue&type=script&lang=js"

import "./MemberTop.vue?vue&type=style&index=0&id=413ac423&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413ac423"]])

export default __exports__